let config = {
  defaultLayout: 'vertical',
  errorMessages: 'first',
  errorMessagesGlue: '<br />',
  locale: 'en',
  repeaterAddIcon: null,
  repeaterRemoveIcon: null,
};

export default config
